"use client";

import { truncateText } from "lib/utils/string-utils";
import { FC } from "react";
import { Button, Row, Col } from "react-bootstrap";
import SimpleCard from "./simple-card";
import FlexBox from "./flex-box";
import { PiCheckSquareLight, PiInfoLight } from "react-icons/pi";
import SimpleTitle from "./simple-title";

interface PractitionerInfoCardProps {
  practitioner: PractitionerDetails;
  practitionerTherapies?: Therapy[];
  onBookAppointmentClick: (practitionerId: string) => void;
  onProfileViewClick: (practitioner: PractitionerDetails) => void;
}

const PractitionerInfoCard: FC<PractitionerInfoCardProps> = ({
  practitioner,
  practitionerTherapies,
  onBookAppointmentClick,
  onProfileViewClick,
}) => {
  return (
    <SimpleCard className="hover-shadow p-3 simple-card">
      <Row className="align-items-start g-3">
        <Col xs={12}>
          <div className="d-flex flex-column flex-md-row justify-content-between gap-2">
            <div className="d-flex align-items-center gap-2">
              <h4 className="fw-bold mb-0">
                {practitioner?.firstName} {practitioner?.lastName}
              </h4>

              <Button
                variant="outline-secondary"
                size="sm"
                className="d-flex align-items-center justify-content-center p-1"
                onClick={() => onProfileViewClick(practitioner)}
              >
                <PiInfoLight size={20} />
              </Button>
            </div>

            <div className="d-flex justify-content-md-end mt-2 mt-md-0">
              <Button
                className="d-flex align-items-center justify-content-center"
                onClick={() => onBookAppointmentClick(practitioner?.id)}
              >
                Book Appointment
              </Button>
            </div>
          </div>

          <div
            dangerouslySetInnerHTML={{
              __html: truncateText(
                practitioner?.businessSummary !== ""
                  ? practitioner?.businessSummary
                  : practitioner?.biography,
                200
              ),
            }}
            className="text-muted mt-3"
          />

          <SimpleTitle className="mt-3">Specialities</SimpleTitle>
          {practitionerTherapies?.length > 0 && (
            <ol className="mt-2 d-flex flex-wrap gap-3 list-unstyled mb-0">
              {practitionerTherapies.map((therapy) => (
                <li
                  key={therapy?.id}
                  className="text-muted d-flex align-items-center"
                >
                  <PiCheckSquareLight className="me-1" /> {therapy?.name}
                </li>
              ))}
            </ol>
          )}
        </Col>
      </Row>
    </SimpleCard>
  );
};

export default PractitionerInfoCard;
